import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import {
  BusinessLevelMarketingSubscription,
} from './business-level-marketing-subscription.js';

export class BusinessLevelMarketingSubscriber extends DataModel {
  static readonly TYPE_ID: string = '278ccf462a44450ba1e897bd611c95bb';

  private constructor(
    public readonly accountId: string,
    public readonly isGuestAccount: boolean,
    public readonly businessRef: BusinessModuleRef,
    public readonly activeSubscription: BusinessLevelMarketingSubscription,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessLevelMarketingSubscriber.TYPE_ID;
  }

  get uniqueId(): string {
    return this.accountId;
  }

  static create(args: {
    accountId: string,
    isGuestAccount: boolean,
    businessRef: BusinessModuleRef,
    activeSubscription: BusinessLevelMarketingSubscription,
  }): BusinessLevelMarketingSubscriber {
    return new BusinessLevelMarketingSubscriber(
        args.accountId,
        args.isGuestAccount,
        args.businessRef,
        args.activeSubscription,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): BusinessLevelMarketingSubscriber {
    return BusinessLevelMarketingSubscriber.create({
      accountId: MapUtils.getString(map, 'accountId'),
      isGuestAccount: MapUtils.getBoolean(map, 'isGuestAccount'),
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
      activeSubscription: context.fromData(MapUtils.getRecord(map, 'activeSubscription')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      accountId: this.accountId,
      isGuestAccount: this.isGuestAccount,
      businessRef: this.businessRef.encode(),
      activeSubscription: context.toData(this.activeSubscription),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    accountId = this.accountId,
    isGuestAccount = this.isGuestAccount,
    businessRef = this.businessRef,
    activeSubscription = this.activeSubscription,
  }: {
    accountId?: string,
    isGuestAccount?: boolean,
    businessRef?: BusinessModuleRef,
    activeSubscription?: BusinessLevelMarketingSubscription,
  } = {}): this {
    return BusinessLevelMarketingSubscriber.create({
      accountId,
      isGuestAccount,
      businessRef,
      activeSubscription,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.accountId === this.accountId &&
      other.isGuestAccount === this.isGuestAccount &&
      isSameData(other.businessRef, this.businessRef) &&
      isSameData(other.activeSubscription, this.activeSubscription);
  }
}

export class BusinessLevelMarketingSubscriberBuilder extends DataModelBuilder<BusinessLevelMarketingSubscriber> {
  build(context: SerializationContext, map: SerializedData): BusinessLevelMarketingSubscriber {
    return BusinessLevelMarketingSubscriber.fromMap(context, map);
  }
}
